import {BaseModel} from '../../../shared';

export class Mensaje extends BaseModel{
  mensajeId: string;
  mensajeFecha: string;
  personaId: string;
  mensajeContenido: string;
  mensajeLeido: boolean;
}
